import api from "@/services/api";

export default {
  getUncompletedMissions() {
    return api
      .get(`user-mission/get_uncompleted_missions/`)
      .then((response) => response.data);
  },
  getCompletedMissions() {
    return api
      .get(`user-mission/get_completed_missions/`)
      .then((response) => response.data);
  },
  buttonClicked(code) {
    return api
      .get(`user-mission/check_buttons_missions/?code=${code}`)
      .then((response) => response.data);
  },
  getMissions(service) {
    return api
      .get(`user-mission/get_missions/?service=${service}`)
      .then((response) => response.data);
  },
  createWithCode(payload) {
    return api
      .post("missions/create-with-code/", payload)
      .then((response) => response.data);
  },
  getServices() {
    return api.get("missions/services/").then((response) => response.data);
  },
  getUserMissions(user) {
    return api
      .get(`missions/user-missions/?user=${user}`)
      .then((response) => response.data);
  },
  completeUserMission(userMission) {
    return api
      .post("missions/complete/", { user_mission: userMission })
      .then((response) => response.data);
  },
};
